module.exports = __webpack_public_path__ + "images/FUSA_icons/062-24-hours.f90e94831e7b9a7fbefc181764c06df5.svg";